module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.4b236c6c.ttf";